module.exports = __webpack_public_path__ + "843a9b824d618f714a0ee1e2a4f0248d.pdf";